<template>
  <div class="results-wrapper">
    <div class="search-results">
      <template v-if="!labels.hideResults">
        {{ labels.results }} {{ labels.results === 1 ? 'result' : 'results' }}
      </template>
      {{ labels.searchData.length ? ` for '${labels.searchData}'` : '' }}
    </div>
    <template v-if="filterLabels.length">
      <div
        v-for="([category, filter], id) in filterLabels"
        :key="id" class="search-label"
        :class="category"
      >
        {{ filters[category].values[filter].text }}
        <span v-if="filters[category].type === 'multiple' && filterCounts[category] && (filterCounts[category][filter] || filterCounts[category][filter] === 0)">
          ({{ filterCounts[category][filter] }})
        </span>
        <span v-else-if="filters[category].type !== 'multiple' && (filterCounts[category] || filterCounts[category] === 0)">
          ({{ filterCounts[category] }})
        </span>
        <CloseIcon class="close" @click="closeTag(category, filter)" />
      </div>
    </template>
    <div v-if="filterLabels.length" class="clear-all" @click="clearAll">
      Clear all
    </div>
  </div>
</template>

<script>
import CloseIcon from '../assets/svg/icon-close.svg?vue-component';

export default {
  components: {
    CloseIcon,
  },
  props: {
    labels: { type: Object, required: false, default: () => ({}) },
    filters: { type: Object, required: true },
    filterCounts: { type: Object, required: false, default: () => ({}) },
  },
  computed: {
    filterLabels() {
      const labels = [];
      const filters = this.labels.filtersData;
      // eslint-disable-next-line no-restricted-syntax
      for (const topic in filters) {
        if (filters[topic].length > 0) {
          filters[topic].forEach((el) => {
            labels.push([topic, el]);
          });
        }
      }
      return labels;
    },
  },
  methods: {
    closeTag(type, filter) {
      this.$emit('closeLabel', { type, filter });
    },
    clearAll() {
      this.$emit('clearAll');
    },
  },
};
</script>

<style lang="scss" scoped>
.results-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--spacing-16);
  row-gap: 10px;
  margin: var(--spacing-16) 0 var(--spacing-40) 0;

  .search-results {
    font-weight: 500;
    font-size: 16px;
    line-height: 27px;
    color: var(--main-dark-shade-0);
    flex: 100%;
    margin-bottom: 2px;
  }

  .search-label {
    display: flex;
    align-items: center;
    text-align: center;
    padding: var(--spacing-8) var(--spacing-16);
    gap: var(--spacing-8);
    background: var(--main-light-shade-3);
    border-radius: 100px;
    line-height: 110%;
    text-transform: capitalize;

    > span {
      color: var(--main-dark-light-4);
    }

    &.duration {
      text-transform: lowercase;
    }

    &.search {
      text-transform: lowercase;
    }

    .close {
      width: 10px;
      cursor: pointer;
    }
  }

  .clear-all {
    font-weight: 600;
    color: var(--main-dark-shade-4);
    cursor: pointer;
  }
}
</style>
